import React from "react";
import ReactModal from "react-modal";
import * as R from "ramda";
import AccessLevelFormFields from "./AccessLevelFormFields";
import { connect } from "react-redux";
import { updateOne } from "actions/accessLevel";
import Icon from "components/Icon";
import { fetchAll } from "actions/user";

const mapStateToProps = state => ({
  isUpdating: state.location.isUpdating,
  users: state.user.byId,
  isFetchingList: state.user.isFetchingList
});

const mapDispatchToProps = { updateOne, fetchAll };

class UpdateAccessLevelModal extends React.Component {
  constructor(props) {
    super(props);

    const readers = props.accessLevel.readers;

    readers.sort((a, b) => {
      const aname = a.name.toUpperCase();
      const bname = b.name.toUpperCase();
      if (aname < bname) {
        return -1;
      }
      if (aname > bname) {
        return 1;
      }
      return 0;
    });

    this.state = {
      showModal: false,
      accessLevel: {
        ...props.accessLevel,
        readers: readers.map(({ id, name }) => ({
          id,
          name
        }))
      }
    };
  }

  componentWillMount() {
    const { isFetchingList } = this.props;
    if (!isFetchingList) {
      this.props.fetchAll();
    }
  }

  handleSubmit = event => {
    event.preventDefault();
    const { updateOne } = this.props;
    const { accessLevel } = this.state;
    console.log(accessLevel);

    const data = {
      ...accessLevel,
      readers: accessLevel.readers.filter(r => !!r).map(({ id }) => id)
    };

    updateOne(accessLevel.id, data).then(this.handleCloseModal);
  };

  handleChange = (fields, value) => {
    console.log(fields);
    console.log(value);
    this.setState(R.assocPath(fields, value));
  };

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleReaderChange = (idx, value) => {
    if (value != null) {
      const { users, accessLevel } = this.props;
      value = R.find(
        R.propEq("id", ~~value),
        users[accessLevel.user_id].readers
      );
    }
    this.setState(R.assocPath(["accessLevel", "readers", idx], value));
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id).then(this.handleCloseModal);
  };

  render() {
    const { title, users } = this.props;
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.handleOpenModal}
        >
          <Icon icon="pencil-alt" />
        </button>
        <ReactModal
          onRequestClose={this.handleCloseModal}
          className="Modal"
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          contentLabel="Delete Confirmation"
        >
          <form onSubmit={this.handleSubmit}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                </div>
                <div className="modal-body">
                  <AccessLevelFormFields
                    accessLevel={this.state.accessLevel}
                    onChange={this.handleChange}
                    onReaderChange={this.handleReaderChange}
                    users={users}
                    user={users[this.state.accessLevel.user_id]}
                  />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" type="submit">
                    Rediger
                  </button>
                  <button className="btn" onClick={this.handleCloseModal}>
                    Avbryt
                  </button>
                </div>
              </div>
            </div>
          </form>
        </ReactModal>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  UpdateAccessLevelModal
);



// WEBPACK FOOTER //
// ./src/components/UpdateAccessLevelModal.js